import { useTheme } from 'styled-components';

type PropsType = {
  overrideStyle?: Record<any, any>;
};

const YoutubeIcon = ({ overrideStyle = {} }: PropsType) => {
  const theme = useTheme();
  return (
    <svg viewBox="0 0 61 46" style={{ ...overrideStyle }}>
      <path
        d="M50.6355 0.263184H10.5254C7.80406 0.263184 5.19421 1.43431 3.26995 3.51892C1.34569 5.60354 0.264648 8.43088 0.264648 11.379V34.6211C0.264648 37.5692 1.34569 40.3965 3.26995 42.4811C5.19421 44.5657 7.80406 45.7369 10.5254 45.7369H50.6355C53.3568 45.7369 55.9667 44.5657 57.8909 42.4811C59.8152 40.3965 60.8962 37.5692 60.8962 34.6211V11.379C60.8962 8.43088 59.8152 5.60354 57.8909 3.51892C55.9667 1.43431 53.3568 0.263184 50.6355 0.263184ZM42.884 24.344L24.6945 34.4493C24.4814 34.5689 24.2434 34.6271 24.0035 34.6183C23.7636 34.6095 23.5298 34.534 23.3246 34.399C23.1194 34.264 22.9497 34.0741 22.8319 33.8475C22.714 33.6209 22.652 33.3653 22.6517 33.1053V12.8948C22.652 12.6347 22.714 12.3791 22.8319 12.1525C22.9497 11.926 23.1194 11.7361 23.3246 11.6011C23.5298 11.4661 23.7636 11.3906 24.0035 11.3817C24.2434 11.3729 24.4814 11.4311 24.6945 11.5508L42.884 21.656C43.1132 21.7832 43.3055 21.9765 43.4398 22.2145C43.5741 22.4525 43.6452 22.7261 43.6452 23.0051C43.6452 23.2841 43.5741 23.5576 43.4398 23.7956C43.3055 24.0337 43.1132 24.2269 42.884 24.3541V24.344Z"
        fill={overrideStyle.color || theme.black}
      />
    </svg>
  );
};

export default YoutubeIcon;
